import {
    SET_DOC_ACCOR
} from '../../actions';

const initialState = {
    boolean: true
}

function docAccordReducer(state = initialState, action ) {
    const newState = {};

    switch (action.type) {
        case SET_DOC_ACCOR:
            newState.boolean = action.status;
            return newState;
        
        default:
            return state;

    }
}

export default docAccordReducer;
